<template>
  <SortTableComponent
    :actions="actions"
    :apiFilters="false"
    :columns="columns"
    :datas="datas"
    :loading="loading"
    :idKey="4"
    statusKey="1"
    :isSearchAvailable="true"
    :maxResult="maxResult"
    :keyword="keyword"
    type="registration-contract"
    ref="sortTable"
  />
</template>

<script>
import SortTableComponent from "@/components/table/sortTable/SortTableComponent.vue";
import { sortableTableManager } from "@/services/utilities/sortable-table-manager";
import { accessManager } from "@/services/security/access-manager";

export default {
  components: { SortTableComponent },
  props: {
    contracts: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      columns: [],
      datas: [],
      maxResult: 0,
      keyword: "",
      actions: [
        {
          translation: "registration.group_action.see_sheet",
          icon: "eye",
          type: "success",
          actionType: "router",
          action: "TrainingPreRegistration",
          cfaStyle: false,
          alias: "training",
          access: accessManager.EDIT,
          paramsIndexes: {
            registration: 9,
            group: 10,
          },
          params: {
            tab: 1,
          },
        },
      ],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (this.contracts && Object.keys(this.contracts).length) {
        this.datas = this.contracts.data;
        this.columns = sortableTableManager.getEntriesColumns(this.contracts.columns);
        this.maxResult = this.contracts.count;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
